import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { UserService } from '../services/user.service';

@Injectable()
export class LoginRouteGuard  {

  constructor(private router: Router, private userService: UserService) { }

  canActivate() {

    if (this.userService.isLogged()) {
      return true
    } else {
      this.router.navigate(['/pages/login'])
      return false
    }

  }

}



@Injectable()
export class NotLoginRouteGuard  {

  constructor(private router: Router, private userService: UserService) { }

  canActivate() {
    if (this.userService.isLogged()) {
      this.router.navigate(['/dashboard/dashboard1'])
      return false
    } else {
      return true
    }

  }


}